import { AlertCircle, Percent } from "lucide-react";

import { tipoDaForma } from "../lib/sugestoes";
import { pct, reais } from "../lib/simulacao";

// Forma que costuma ter taxa (cartão, vale, iFood, online) e está sem nada
// configurado deixa o DRE e o Fluxo de Caixa otimistas — ganha destaque.
const COSTUMA_TER_TAXA = ["credito", "debito", "cartao", "voucher", "ifood", "online_pix", "online_cartao"];

export const semTaxaQueDeveria = (item) => {
  if (!item || item.configurada) return false;
  const tipo = tipoDaForma(item.nome, item.chave);
  return !!tipo && COSTUMA_TER_TAXA.includes(tipo.tipo);
};

/** "3,19% · D+30" — ou o convite para configurar. */
export default function TaxaResumo({ item, onClick }) {
  if (!item?.configurada) {
    const alerta = semTaxaQueDeveria(item);
    return (
      <button type="button" onClick={onClick}
        className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-lg border transition-colors ${alerta ? "border-amber-500/40 bg-amber-500/10 text-amber-700 dark:text-amber-400 hover:bg-amber-500/20" : "text-muted-foreground hover:bg-muted"}`}>
        {alerta ? <AlertCircle className="w-3.5 h-3.5" /> : <Percent className="w-3.5 h-3.5" />}Definir taxa e prazo
      </button>
    );
  }
  const fixa = Number(item.taxa_fixa) > 0 ? ` + ${reais(item.taxa_fixa)}` : "";
  return (
    <button type="button" onClick={onClick} title="Taxa e prazo de recebimento"
      className="inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded-lg bg-primary/10 text-primary font-semibold hover:bg-primary/15 transition-colors tabular-nums">
      <Percent className="w-3.5 h-3.5" />{pct(item.taxa_percentual)}{fixa}<span className="font-normal opacity-80">· D+{item.prazo_dias}</span>
    </button>
  );
}
